import { getAuthToken, removeAuthToken } from './accessTokens';
import { getEnv } from '../helpers/getEnv';
import axios, { InternalAxiosRequestConfig } from 'axios';

export const DEFAULT_ERROR_MESSAGE = 'Oops, something went wrong';
export const DEFAULT_SAVED_MESSAGE = 'Changes have been saved';

/**
 * Helper function to get the current agent ID
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getCurrentAgentId = (): number | undefined => (window as any).currentAgentID;

export const privateFulcrumApi = axios.create({
  baseURL: getEnv('REACT_APP_API_URL'),
});

privateFulcrumApi.interceptors.request.use((config) => ({
  ...config,
  // Add the current agent ID to the GET requests
  params:
    config.method === 'get'
      ? {
          ...config.params,
          agentID: getCurrentAgentId(),
        }
      : config.params,
  // Add the current agent ID to the POST requests payload
  data: config.method === 'get' ? config.data : { ...config.data, agentID: getCurrentAgentId() },
  headers: {
    ...config.headers,
    Authorization: `Bearer ${getAuthToken('fulcrumToken')}`,
  } as InternalAxiosRequestConfig['headers'],
}));

privateFulcrumApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      removeAuthToken();
      window.location.reload();
    }
    throw error;
  },
);
